import { UpdatePage } from '@components/molecules';
import { TextFieldElement, SwitchElement, useForm } from 'react-hook-form-mui';
import API from '@apps/localization/services/city';
import CountryAPI from '@apps/localization/services/country';
import { ModelProps } from '@/types';
import { CitySchema, CitySchemaType } from '@apps/localization/schemas/city';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';

export default function ObjectUpdatePage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const formContext = useForm<CitySchemaType>({
    resolver: zodResolver(CitySchema),
    defaultValues: { is_active: true },
  });
  return (
    <UpdatePage
      schema={CitySchema}
      api={API}
      title={t('City')}
      modelProps={modelProps}
      formcontext={formContext}
      canSaveAndContinue
      keepValues={['country', 'timezone']}
    >
      <Grid size={{ xs: 12, md: 6 }}>
        <TextFieldElement name="name" label={t('Name')} fullWidth required />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          api={API.timezone}
          name="timezone"
          label={t('Timezone')}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <AsyncAutocompleteElement
          api={CountryAPI.select}
          name="country"
          label={t('Country')}
          required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <SwitchElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </UpdatePage>
  );
}
